import { accounts } from "./Account.slice";

export const accountActions = { ...accounts.actions };
